import React, { Component } from 'react'
import './submenu.scss'

class Submenu extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	render() {
		let classes = ['vbui--submenu', this.props.classes, this.props.state].join(' ')

		return (
			<div className={classes}>
				<div className="submenu-content container">
					{this.props.links.map((link, i) => {
						let active = ''
						if (this.props.selected === link.to) {
							active = 'active'
						}
						return (
							<a key={i} className={active} href={link.to} data-id={i} onClick={this.props.onClick}>
								{link.icon && <span className={link.icon}></span>}
								{link.text}
							</a>
						)
					})}
					{this.props.children && <div className="right-float-carrier">{this.props.children}</div>}
				</div>
			</div>
		)
	}
}

export default Submenu
